import MuiFormHelperText, { FormHelperTextProps as MuiFormHelperTextProps } from '@mui/material/FormHelperText';
import * as React from 'react';

export interface FormHelperTextProps extends MuiFormHelperTextProps {}

export const FormHelperText = (props: FormHelperTextProps) => {
  return <MuiFormHelperText {...props} />;
};
